export default __webpack_public_path__ + "static/media/AdventureHexOnlineLogo.b26009df.png";